// frontend/src/constants.js
export const SERVICE_OPTIONS = ["Board Member", "Private Banking", "Trustee", "Other"];
export const ACTIVITY_OPTIONS = ["Protection of Assets", "Trading", "Holding", "Other"];
export const GROUP_PURPOSE_OPTIONS = ["N/A", "Tax Planning", "Wealth Mgmt", "Other"];
export const TRANSACTION_PROFILE_OPTIONS = [
  { value: "1", label: "Y" },
  { value: "0", label: "N" },
  { value: "", label: "N/A" },
];
export const TX_LABELS = {
  payments: "Payments",
  cheques: "Cheques",
  crypto_related: "Crypto related",
  securities: "Securities",
  other: "Other",
};
export const TX_TYPE_OPTIONS = Object.entries(TX_LABELS).map(([value, label]) => ({ value, label }));
export const DOC_KIND_OPTIONS = [
  { value: "CRIB_NUMMER", label: "CRIB nummer" },
  { value: "FINANCIAL_STATEMENTS", label: "Financial Statements" },
  { value: "VESTIGINGS_VERGUNNING", label: "Vestigingsvergunning" },
  { value: "DEVIEZEN_VRIJSTELLING", label: "Deviezenvrijstelling" },
  { value: "Passport", label: "Passport" },
  { value: "National ID", label: "National ID" },
  { value: "CoC Form", label: "CoC Form" },
  { value: "Bank Statement", label: "Bank Statement" },
  { value: "Permit", label: "Permit" },
  { value: "Business License", label: "Business License" },
  { value: "Service Request", label: "Service Request" },
  { value: "Management Agreement", label: "Management Agreement" },
  { value: "Other", label: "Other" },
];

// Common ISO currency options — extend as needed
export const CURRENCY_OPTIONS = [
  { value: "USD", label: "USD — US Dollar" },
  { value: "EUR", label: "EUR — Euro" },
  { value: "XCG", label: "XCG — Caribbean Guilder" },
  { value: "AWG", label: "AWG — Aruban Florin" },
  { value: "GBP", label: "GBP — British Pound" },
  { value: "CAD", label: "CAD — Canadian Dollar" },
  { value: "CNY", label: "CNY — Chinese Yuan" },
  { value: "JPY", label: "JPY — Japanese Yen" },
  { value: "Other", label: "Other" },
];
